import React, { useEffect } from 'react';
const PIXEL_ID = '932239743083439';
type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelInitialized?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.__metaPixelInitialized) return;
    window.__metaPixelInitialized = true;

    /* Meta Pixel Code */
    (function (f: Window, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod(...args);
        } else {
          n.queue.push(args);
        }
      } as Fbq;
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
    /* End Meta Pixel Code */
  }, []);
  return <noscript data-id="element-22" data-mp="1recjqhyfe0cr">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-23" data-mp="1rduewwxp6dt8" />
    </noscript>;
}